import { Modal } from 'antd';

interface ContactUsTextModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: string | undefined;
}

export const ContactUsTextModal = ({
  isOpen,
  onClose,
  content,
}: ContactUsTextModalProps) => {
  return (
    <Modal
      closable={false}
      open={isOpen}
      centered={true}
      onCancel={onClose}
      footer={[]}
    >
      <div>{content}</div>
    </Modal>
  );
};
